import { useMutation, useQueryClient } from "@tanstack/react-query";
import sceneRepository from "@/repository/sceneRepository";
import { scenarioQueryKeys } from "@/query/scenario";
import { sceneKeys } from "./keys";


export const useDeleteScene = (scenarioId: string) => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, number>({
        mutationFn: async (sceneId: number) => {
            await sceneRepository.deleteScene(scenarioId, sceneId);
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: sceneKeys.all(scenarioId) }),
                queryClient.invalidateQueries({ queryKey: scenarioQueryKeys.autocompletes(scenarioId) })
            ]);
        }
    });
};
